module.exports = __webpack_public_path__ + "quotes-49ede9fc567497dccfd5.png";